module.exports = __webpack_public_path__ + "media/img/pages/companies/brugg-3d5add7bcdad63e39727d988ed27f612.png";